import { render, staticRenderFns } from "./SimpleAttribute.vue?vue&type=template&id=5045b8d1&"
import script from "./SimpleAttribute.vue?vue&type=script&lang=ts&"
export * from "./SimpleAttribute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
